import React from 'react';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import { UnitTypeId } from 'services/unitTypes/types';
import { SprayApplicationRate, SprayProduct } from 'services/sprayEvents/types';
import { makeSelectRatePerHundredLitre } from './selectors';

interface ConnectedProps {
    ratePerHundredLitre: string;
}

export interface OwnProps {
    productId: ProductId;
    applicationRate: SprayApplicationRate;
    product: SprayProduct;
    unitTypeId: UnitTypeId;
}

export type Props = ConnectedProps & OwnProps;

export class RatePerHundredLitreListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { ratePerHundredLitre } = this.props;

        return (
            <ListItem value={ratePerHundredLitre} description="Rate per 100L" />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    ratePerHundredLitre: makeSelectRatePerHundredLitre()
});

export default connect(mapStateToProps)(RatePerHundredLitreListItemComponent);
